// src/redux/publicTeacher/operation.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { url } from "../../baseUrl.js";

export const fetchPublicTeacherProfile = createAsyncThunk(
  "publicTeacher/fetchProfile",
  async (teacherId, thunkAPI) => {
    try {
      const { data } = await axios.get(
        `${url}/api/public/teachers/${teacherId}`
      );
      // console.log(data);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Ошибка загрузки профиля преподавателя"
      );
    }
  }
);

// добавиление пагинации и филтрации
export const fetchPublicTeachers = createAsyncThunk(
  "publicTeachers/fetchAll",
  async (params, thunkAPI) => {
    try {
      const query = new URLSearchParams(params).toString();

      const { data } = await axios.get(
        // или продакшн:

        `${url}/api/public/teachers?${query}`
      );

      // Должно возвращать объект:
      // { teachers: [...], total: N, totalPages: N, currentPage: N }
      // console.log(data);

      return data;
    } catch (err) {
      // Безопасная обработка ошибки
      const message =
        err.response?.data?.message || "Failed to fetch teachers.";
      return thunkAPI.rejectWithValue(message);
    }
  }
);
